import { CultureInfo } from '../culture-info.model';
import { CultureInfoNb } from './nb';

/**
 * @ignore
 */
export const CultureInfoNbNO: CultureInfo = {
  name: 'nb-NO',
  displayName: 'Norwegian Bokmål (Norway)',
  iso3LanguageCode: 'nob',
  iso2LanguageCode: 'nb',
  ietfLanguageTag: 'nb-NO',
  parent: CultureInfoNb
};
